<template>
    <notification type="danger">
        {{ t('widget.errors.client-token-invalid') }}
    </notification>
</template>

<script lang="ts" setup>
import { useTranslations } from '@btcdirect/composables';
import Notification from '../notification/notification.vue';

const { t } = useTranslations();
</script>
